import { palette } from '@livable/saas-react-components';
const MuiTableRow = {
  styleOverrides: {
    root: {
      backgroundColor: palette.shades[100]
    },
    head: {
      borderBottom: "1px solid ".concat(palette.shades[300])
    }
  }
};
export default MuiTableRow;